import { Panel, PanelItemGroup } from '@rta/rta-blueprint-library';

import { transformToGlobal } from './transform-to-global';

export type GetOverheadGroupPositionOptions = {
	/**
	 * When set, overrides the panel-local Z of the returned position (measured from
	 * the panel center along the panel's outward direction, so `panel.size.depth / 2`
	 * lands on the outer face and larger values sit further outside the panel band).
	 * Used to pin TOP_ONLY SKU labels above the panel outline in the mfg /
	 * SKU-overhead view, independent of countertop thickness -- see issue #249.
	 *
	 * The rotation `-panel.getOriginAngle()` still runs, so corner-stand panels
	 * (45°/135°/225°/315°) anchor correctly too.
	 */
	panelLocalZ?: number;
};

/**
 * Gets the island-local position for a panel item group in overhead view.
 * Mirrors the overhead render transform: translate(panelCenter) rotate(-originAngle) translate(groupCenter).
 */
export const getOverheadGroupPosition = (
	panelItemGroup: PanelItemGroup,
	panel: Panel,
	options: GetOverheadGroupPositionOptions = {}
): { x: number; z: number } => {
	const { panelLocalZ } = options;
	const { center: panelCenter } = panel;
	const { center: groupCenter } = panelItemGroup;

	const localX = groupCenter.x;
	const localZ = panelLocalZ ?? groupCenter.z;

	return transformToGlobal(localX, localZ, panelCenter.x, panelCenter.z, -panel.getOriginAngle());
};
